import { ConfigProvider } from "antd"
import React from "react"

import { useAppearance } from "../../../appearance/use-appearance.ts"

/**
 * Scoped design tokens for the customer portal only — a nested ConfigProvider
 * merges onto the GC app's global theme (RootLayout's ConfigProvider) rather
 * than replacing it, so this never touches staff-facing screens. The portal
 * mockup calls for larger, roomier controls than the GC app's default
 * (44px controls, 16px body text, 12px card radius) — this is the single
 * place that sizing is declared instead of hand-tuning every Button/Input/
 * Select instance across eight pages.
 */
export function PortalThemeProvider({
  children
}: {
  children: React.ReactNode
}) {
  const { resolved } = useAppearance()
  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 16,
          controlHeight: 44,
          controlHeightLG: 48,
          controlHeightSM: 36,
          borderRadius: 12,
          borderRadiusLG: 12
        },
        components: {
          Button: {
            fontWeight: 500,
            paddingInline: 20,
            borderRadius: 10
          },
          Input: { borderRadius: 8 },
          Select: { borderRadius: 8 },
          Segmented: {
            borderRadius: 8,
            itemColor: resolved === "dark" ? "#A3AEBE" : "#475569"
          },
          Tag: {
            borderRadius: 8,
            borderRadiusXS: 8,
            borderRadiusSM: 8,
            borderRadiusLG: 8
          }
        }
      }}
    >
      {children}
    </ConfigProvider>
  )
}
